// Action Types
const OPEN_MODE = "toast/OPEN_MODE";
const CLOSE_MODE = "toast/CLOSE_MODE";
const UPDATE_MODE = "toast/UPDATE_MODE";

// Action Creators
export const openToast = (info) => ({ type: OPEN_MODE, info });
export const closeToast = (info) => ({ type: CLOSE_MODE, info });
export const updateToast = (info) => ({ type: UPDATE_MODE, info });

// Initial
const initialToastState = {
    isShow: false,
    toastId: null,
    toastImg: null,
    msg: "",
};

export default function toastReducer(state = initialToastState, action) {
    switch (action.type) {
        case OPEN_MODE:
            return {
                ...state,
                isShow: true,
                toastId: action.info.toastId,
                toastImg: action.info.toastImg,
                msg: action.info.msg,
            };

        case CLOSE_MODE:
            return {
                ...state,
                isShow: false,
                toastId: null,
                toastImg: null,
                msg: "",
            };

        case UPDATE_MODE:
            return {
                ...state,
                toastId: action.info.toastId,
            };
        default:
            return state;
    }
}
